import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

const BackgroundColorMixinProps = Vue.extend({
  props: {
    bgColor: String,
  },
});

@Component
export default class BackgroundColorMixin extends mixins(BackgroundColorMixinProps) {
  get getBackgroundColorStyle (): Record<string, string> {
    let bgStyleColor;
    let textStyleColor;

    if (this.bgColor === 'background-white') {
      bgStyleColor = 'var(--text-on-base-color)';
      textStyleColor = 'var(--base-color)';
    } else if (this.bgColor === 'background-theme') {
      bgStyleColor = 'var(--campaign-gradient)';
      textStyleColor = 'var(--campaign-text)';
    } else {
      bgStyleColor = 'var(--base-color)';
      textStyleColor = 'var(--text-on-base-color)';
    }

    return {
      '--background-color': bgStyleColor,
      '--text-color': textStyleColor,
    };
  }
}
